import React from 'react';
import { useLanguage } from './LanguageContext';
import { Award, Clock, Tag, Sparkles } from 'lucide-react';
export const WhyChooseUs = () => {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <Award className="w-7 h-7 md:w-8 md:h-8" data-id="element-257" />,
    title: t('why.c1.title'),
    desc: t('why.c1.desc')
  }, {
    icon: <Clock className="w-7 h-7 md:w-8 md:h-8" data-id="element-258" />,
    title: t('why.c2.title'),
    desc: t('why.c2.desc')
  }, {
    icon: <Tag className="w-7 h-7 md:w-8 md:h-8" data-id="element-259" />,
    title: t('why.c3.title'),
    desc: t('why.c3.desc')
  }, {
    icon: <Sparkles className="w-7 h-7 md:w-8 md:h-8" data-id="element-260" />,
    title: t('why.c4.title'),
    desc: t('why.c4.desc')
  }];
  return <section id="about" className="bg-white py-16 md:py-20" data-id="element-261">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
        <h2 className="font-montserrat font-extrabold text-[28px] md:text-[42px] text-brand-navy text-center mb-12 md:mb-16 leading-tight" data-id="element-263">
          {t('why.title1')}
          <br data-id="element-264" />
          <span className="text-brand-gold font-script font-bold text-[34px] md:text-[52px]" data-id="element-265">
            {t('why.title2')}
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto" data-id="element-266">
          {features.map((feature, index) => <div key={index} className="bg-[#F8F6FF] border border-brand-gold/20 rounded-[16px] p-5 md:p-8 hover:border-brand-gold hover:shadow-card-hover transition-all duration-300" data-id="element-267">
              <div className="w-12 h-12 md:w-[64px] md:h-[64px] rounded-full bg-brand-navy flex items-center justify-center text-white mb-3 md:mb-6" data-id="element-268">
                {feature.icon}
              </div>
              <h3 className="font-montserrat font-bold text-base md:text-xl text-brand-navy mb-1.5 md:mb-3" data-id="element-269">
                {feature.title}
              </h3>
              <p className="font-inter text-[14px] md:text-base text-gray-600 leading-relaxed" data-id="element-270">
                {feature.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};